import { Dropdown, DropdownButton, SimpleDropdownItem } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { CrmEnrichmentI18nKeys } from "app/pages/sales-intelligence/modules/crm-enrichment/types/translations";

import type { Operator } from "../../../types/types";

type OperatorDropdownProps = {
    operator: Operator | "";
    appendTo: string;
    translationKeys: CrmEnrichmentI18nKeys;
    options: readonly Operator[];
    onOperatorChange: (operatorValue: Operator) => void;
};

const OperatorDropdown = ({
    operator,
    appendTo,
    options,
    translationKeys,
    onOperatorChange,
}: OperatorDropdownProps) => {
    return (
        <Dropdown
            selectedIds={operator ? { operator: true } : {}}
            dropdownPopupHeight={232}
            itemsComponent={SimpleDropdownItem}
            appendTo={appendTo}
            onClick={({ id }: { id: Operator }) => onOperatorChange(id)}
        >
            {[
                <DropdownButton key="dd-btn">
                    <I18n
                        translatable={{
                            key: operator
                                ? translate(translationKeys.operator(operator))
                                : translate("si.crm-enrichment.job-wizard.filters.operator.placeholder"),
                        }}
                    />
                </DropdownButton>,
                ...options.map((operatorOption) => ({
                    key: operatorOption,
                    id: operatorOption,
                    text: translate(translationKeys.operator(operatorOption)),
                    selected: operatorOption === operator,
                })),
            ]}
        </Dropdown>
    );
};

export default OperatorDropdown;
